import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectCoverSlide(props: SlideProps) {
  return <SlideLayout {...props} theme="brand" data-id="element-148">
      <div className="flex flex-col items-start max-w-4xl" data-id="element-149">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-indigo-100 text-sm font-medium mb-8 backdrop-blur-sm" data-id="element-150">
          <Sparkles className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-151" />
          <span data-id="element-152">For Educators & Institutions</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight leading-tight" data-id="element-153">
          Transform Your <br data-id="element-154" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-emerald-300" data-id="element-155">
            Assessment Creation
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-indigo-100 max-w-2xl leading-relaxed mb-10" data-id="element-156">
          Turn weeks of manual work into seconds of AI magic. Generate
          professional, branded assessments from any content instantly.
        </p>

        <div className="flex gap-4" data-id="element-157">
          <button onClick={props.onNext} className="group flex items-center gap-3 bg-white text-indigo-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-indigo-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-158">
            See How It Works
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-159" />
          </button>
        </div>
      </div>
    </SlideLayout>;
}